export const GET_SESSIONS = 'sessions/allSessions/get';